<template>
  <div
    ref="target"
  >
    <slot />
  </div>
</template>

<script>
import Letterize from "letterizejs";
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default {
  mounted() {
    this.animate();
  },
  methods: {
    animate() {
      let mm = gsap.matchMedia();
      const target = this.$refs.target;

      const overlay = target.querySelectorAll('.hero__home-overlay');
      const overlayTexts = target.querySelectorAll('.hero__home-overlay .context__heading > span > span > span');

      const letterWrappers = new Letterize({targets: overlayTexts});
      const letters = new Letterize({targets: letterWrappers.listAll});

      if (overlay) {
        gsap.to(
          target,
          {
            scrollTrigger: {
              trigger: target,
              toggleActions: 'restart none none reverse',
              start: 'top',
              end: 'bottom 60%',
              scrub: 1,
            },
            marginLeft: '20px',
            marginRight: '20px'
          }
        )

        gsap.to(
          letters.listAll,
          {
            scrollTrigger: {
              trigger: target,
              toggleActions: 'restart none none reverse',
              start: 'top',
              end: 'bottom 60%',
              scrub: 1,
            },
            // filter: "invert(80%)",
            translateX: '-20%',
            opacity: 0,
            // duration: 0.3,
            stagger: 0.08,
          }
        )
      }
    }
  }
}
</script>